/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export const $SearchCompanyResponse = {
  type: 'all-of',
  contains: [{
    type: 'Response',
  }, {
    properties: {
      data: {
        type: 'array',
        contains: {
          type: 'CompanyToHireInfo',
        },
        isRequired: true,
      },
    },
  }],
} as const;
